module.exports = __webpack_public_path__ + "static/media/img_10.9cb45bcf.png";